import { render, staticRenderFns } from "./linechart.vue?vue&type=template&id=4c90a886&scoped=true&"
import script from "./linechart.vue?vue&type=script&lang=js&"
export * from "./linechart.vue?vue&type=script&lang=js&"
import style0 from "./linechart.vue?vue&type=style&index=0&id=4c90a886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c90a886",
  null
  
)

export default component.exports